import { useIntl } from 'react-intl';

import { ErrorStateFallback } from '@/components/ui/error-state';
import { Header } from '@/components/ui/header';
import { Title } from '@/components/ui/title';
import { TableProvider } from '@/contexts/table-context';

import { OpeningsTable } from './openings-table';

export function AllOpenings() {
  const intl = useIntl();
  const openingsIntl = intl.formatMessage({
    defaultMessage: 'All Openings',
    description:
      'Page title for the list of org jobs (manage sourcing inclusion)',
  });

  return (
    <TableProvider>
      <main className="relative flex flex-1 flex-col gap-4 px-6 py-2">
        <ErrorStateFallback>
          <Header headers={[{ title: openingsIntl }]} />
          <Title title={openingsIntl} />
          <OpeningsTable />
        </ErrorStateFallback>
      </main>
    </TableProvider>
  );
}
